import styled from 'styled-components';

export const FileInputWrap = styled.div`
  margin-top: 22px;
`;

export const FileTemsWrap = styled.div`
  margin-top: 15px;
`;
